export default __webpack_public_path__ + "static/media/icon-long-arrow-alt-up-solid.f77ef20a.svg";